<div #telInput>
  <app-control-wrapper
    [control]="inputFormControl.invalid ? inputFormControl : fc"
    [errors]="errors"
    [helper]="helper"
    [ngClass]="customClass"
    [isShowHelper]="isShowHelper"
  >
    <label control-label [for]="id">
      {{ label | translate }}
      <i class="fa fa-asterisk form-required" aria-hidden="true" *ngIf="required"></i>
    </label>
    <div control-wrapper [style.position]="'relative'">
      <ngx-intl-tel-input
        [ngClass]="{ stretch: isStretch }"
        [cssClass]="'custom form-control'"
        [id]="id"
        [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="true"
        [enablePlaceholder]="false"
        [maxLength]="14"
        [formControl]="inputFormControl"
      ></ngx-intl-tel-input>

      <span class="phone-verified" *ngIf="isShowConfirmed">
        <img alt="check" src="assets/icons/icon_phone_verified.svg" />
      </span>
    </div>
  </app-control-wrapper>
</div>
